import React, { useState, useMemo, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CardContent from '@material-ui/core/CardContent';

import Comment from 'app/components/comments/Comment';
import CommentSkeleton from 'app/components/comments/CommentSkeleton';
import EditCommentField from 'app/components/comments/EditCommentField';

import useApp from 'app/context/useApp';
import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    cardContentCollapsed: {
        paddingTop: 0,
        position: 'relative'
    },
}));

export default function CommentContainer(props) {

    const { app } = useApp();
    const api = useApi();

    const { commentableType, commentableId, count = 1, onPostComment, onDeleteComment } = props

    const classes = useStyles();

    const [ comments, setComments ] = useState([]);
    const [ loading, setLoading ] = useState(null);

    const getComments = () => {
        setLoading(true);

        api.get(`/comment/${commentableType}/${commentableId}`)
            .then(res => setComments(res.comments))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (count > 0) getComments();
    }, [count]);

    const handleComment = () => {
        getComments();
        if (onPostComment) onPostComment();
    }

    const commentsDeleting = () => {
        getComments();
        if (onDeleteComment) onDeleteComment();
    }

    return (
        <CardContent className={classes.cardContentCollapsed}>
            {loading ? Array.from(Array(count)).map((x, i) => (
                <CommentSkeleton key={i} />
            )) : comments.map(comment => (
                <Comment
                    key={comment.id}
                    comment={comment}
                    app={app}
                    onDelete={commentsDeleting}
                    onDeleted={getComments}
                />
            ))}
            <EditCommentField
                commentableType={commentableType}
                commentableId={commentableId}
                app={app}
                onComment={handleComment}
            />
        </CardContent>
    )
}
